'use client'
import Link from 'next/link'
import React from 'react'

function WeDeliverBigger() {
   return (
      <section className="section_primary_bg home-bg-add-video">
         <div className="video-background">
            <video autoPlay muted loop playsInline>
               <source src="/assets/videos/home/home-2.mp4" type="video/mp4" />
            </video>
         </div>
         <div className="container-fluid d-flex align-items-center justify-content-center flex-wrap">
            <h2 className="we-dont second-section-title">
               We don’t just talk big -
            </h2>
            <h2 className="we-deliver second-section-title">
               we deliver bigger
            </h2>
         </div>
         <div className="container">
            <p className="section_desc cs-text-secondary pt-3 home-second-desc">
               Describe your service here. What makes it great? Use short catchy
               text to tell people what you offer, and the benefits they will
               receive. A great description gets readers in the mood, and makes
               them more likely to go ahead and book.
            </p>
         </div>
         <div className="home-second-div-wrap">
            <div className="home-second-wrap">
               <div className="row align-items-center">
                  <div className="col-md-6 col-lg-7 text-center">
                     <div className="img-title-wrap">
                        <img src="/assets/svg/home/ai-ml.svg" />
                        <Link href="/services/ai-ml-development-company">
                           <h3 className="home-second-section-title">AI-ML</h3>
                        </Link>
                     </div>
                  </div>
                  <div className="col-md-6 col-lg-5 text-start title-des-wrap">
                     <p className="section_desc cs-text-secondary home-second-sub-title text-start">
                        Empowering Tomorrow with Intelligent Innovation!
                     </p>
                     <p className="section_desc cs-text-secondary text-start">
                        Dive into a world where machines don’t just learn—they
                        evolve, predict, and transform the game. Our AI-ML
                        solutions don’t mess around; they’re built to outsmart
                        challenges and supercharge your ideas. Ready to make the
                        impossible happen?
                     </p>
                  </div>
               </div>
            </div>
            <div className="home-second-wrap">
               <div className="row align-items-center">
                  <div className="col-md-6 col-lg-7 text-center">
                     <div className="img-title-wrap">
                        <img src="/assets/svg/home/fin-tech.svg" />
                        <Link href="/industries/fintech-software-development-solutions">
                           <h3 className="home-second-section-title">
                              Fin-Tech
                           </h3>
                        </Link>
                     </div>
                  </div>
                  <div className="col-md-6 col-lg-5 text-start title-des-wrap">
                     <p className="section_desc cs-text-secondary home-second-sub-title text-start">
                        Money Moves, Redefined!
                     </p>
                     <p className="section_desc cs-text-secondary text-start">
                        Say goodbye to boring banking and hello to Fin-Tech that
                        packs a punch. We’re talking seamless transactions,
                        next-level security, and financial freedom that fits
                        your vibe. Let’s make your wallet work smarter, not
                        harder—starting now!
                     </p>
                  </div>
               </div>
            </div>
            <div className="home-second-wrap">
               <div className="row align-items-center">
                  <div className="col-md-6 col-lg-7 text-center">
                     <div className="img-title-wrap">
                        <img src="/assets/svg/home/Lifestyle.svg" />
                        <h3 className="home-second-section-title">Lifestyle</h3>
                     </div>
                  </div>
                  <div className="col-md-6 col-lg-5 text-start title-des-wrap">
                     <p className="section_desc cs-text-secondary home-second-sub-title text-start">
                        Live Bold, Live Better!
                     </p>
                     <p className="section_desc cs-text-secondary text-start">
                        Your lifestyle deserves an upgrade, and we’re here to
                        make it epic. From fitness hacks to self-care wins,
                        we’ve got the tools to level up your daily grind. Why
                        settle for ordinary when you can live extraordinary?
                     </p>
                  </div>
               </div>
            </div>
            <div className="home-second-wrap remove-bottom-border">
               <div className="row align-items-center">
                  <div className="col-md-6 col-lg-7 text-center">
                     <div className="img-title-wrap">
                        <img src="/assets/svg/home/Health-Tech.svg" />
                        <Link href="/industries/health-fitness-software-development-solutions">
                           <h3 className="home-second-section-title">
                              Health-Tech
                           </h3>
                        </Link>
                     </div>
                  </div>
                  <div className="col-md-6 col-lg-5 text-start title-des-wrap">
                     <p className="section_desc cs-text-secondary home-second-sub-title text-start">
                        Your Health, Our Tech—Game On!
                     </p>
                     <p className="section_desc cs-text-secondary text-start">
                        Take charge of your well-being with Health-Tech that’s
                        as fierce as you are. Track, optimize, and thrive with
                        cutting-edge tools designed to keep you at your best.
                        Let’s make healthy living the ultimate flex—starting
                        today!
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default WeDeliverBigger
